import FileUpload from 'components/form_components/fileUpload';
import MROTextField from 'components/form_components/TextField';
import React, { useContext, useEffect, useMemo, useState } from 'react'
import useQuoteStyles from '../utils/QuoteStyles';
import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, IconButton, MenuItem, Typography, useTheme } from '@material-ui/core';
import MROButton from 'components/buttons';
import AddIconBox from "@material-ui/icons/AddBox";
import MaterialTable from 'material-table';
import NumericIncrement from "components/numeric_increment_job_clockings";
import { ToastMessageContext } from 'lib/contexts/message_context';
import RestoreIcon from '@material-ui/icons/Restore';
import WarningIcon from "@material-ui/icons/Warning";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import YesNoField from 'components/form_components/YesNoField';
import tableIcons, { options } from 'components/universal/table_attributes';
import { ICON_COLOUR } from 'lib/constants/style_constants';
import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation';
import PriceBrand from '../../QuotePopUp/PriceBrand';
import BoxpDataService from 'lib/services/api/boxp_index';
import PartPricing from '../../Commercial/LookupPricing/PartPricing';







export default function PricingSection(props) {
    const classes = useQuoteStyles()
    const {
        errors,
        resetErrorsHandler,
        disabled,
        access,
        quotation,
        handlePopup,
        loading,
        setActions,
        input,
        setInput,
        disabledAccptance,
        selectedCustomerId,
        cusExist,
        action,
        setRate,
        quoteId,
        salesRate,
        projectState,
        sum,
        internalNotes, busy,
        setInternalFiles,
        detailedBreakDown,
        setDetailedBreakDown,
        quantityPrice,
        setQuantityPrice,
        getQuotation,
        setBusy,
        setCurrentSelectedData,
        currentSelectedData,
        priceBreakDetails,
        currencyName,
        setInternalNotes,
        quoteComments,
        setQuoteComments,
        setLoading,
        setPriceBreaksDetails,
        actions,
        workshopOrder,
        workshop_order_id,
        states,
        setStates,
        selectedPart,
        rate,
        setTatquantity,
        setStandardId,
        isGettingDetails
    } = props;


    const [pages, setPages] = useState(0);
    const [totalCounts, setTotalCounts] = useState(5);
    const [pageSizes, setPageSizes] = useState(5);
    const theme = useTheme()
    const message = useContext(ToastMessageContext)
    const [filterData, setFilterData] = useState({
        shipping_type: "",
    })



    useEffect(() => {
        if (action === "Unlock") {
            setStates({ man_hours: quotation?.shipping_fee })
            setFilterData({ shipping_type: quotation?.shipping_type })
            setQuoteComments(quotation?.quote_comments)
        }
    }, [quotation]);




    useEffect(() => {
        if (workshop_order_id) {
            getAllPriceBreaks()
        }
    }, [workshop_order_id, quotation?.workshop_order_id])

    useMemo(() => {
        if (priceBreakDetails.length > 1) {
            setQuantityPrice('yes')
        }
    }, [quantityPrice, priceBreakDetails])

    const handleBreakDown = (value) => {
        if (value) {
            setDetailedBreakDown(value)
        }
        handlePopup()

    }
    useEffect(() => {
        if (quantityPrice === 'yes') {
            getAllPriceBreaks()
        }
    }, [quantityPrice, quotation, pages, totalCounts, pageSizes])

    const getAllPriceBreaks = () => {
        const params = {
            page: pages + 1,
            limit: pageSizes,
            workshop_order_id: workshop_order_id
        }
        setLoading(true)
        MaintenanceServices.getAllPriceBreaks(params)
            .then((res) => {
                setLoading(false)
                setTotalCounts(res.total_count)
                setPriceBreaksDetails(res.data)
            }).catch(() => {
                setLoading(false)
                console.log("error")
            })
    }
    const deleteFileHandler = async (id) => {
        setBusy("file-deleting");
        try {
            const response = await MaintenanceServices.deleteFile(id);

            if (response.success) {
                message.showToastMessage({
                    message: "File deleted successfully",
                    variant: "success",
                });
                getQuotation();
                // setBusy(null);
            }
            setBusy(null);
        } catch (error) {
            message.showToastMessage({
                message: "Something went wrong",
                variant: "error",
            });
            setBusy("file-deleting-error");
        }
    }

    const handlePriceBreakUnitPrice = (data) => {

        let unit_price = sum * (1 - (data?.discount / 100))
        return unit_price === 0 ? "0.00" : unit_price.toFixed(2)
    }

    const handleInput = function (e) {
        const { value } = e.target;
        if (value.match(/\./g)) {
            const [, decimal] = value.split(".");

            // restrict value to only 2 decimal places
            if (decimal?.length > 2) {
                // do nothing
                return;
            }
        }
        // setState((ps) => ({ ...ps, isEditing: true }));
        setInput({
            ...input,
            [e.target.name]: e.target.value,
        });
    };
    const tableOptions = {
        ...options,
        page: pages,
        total: totalCounts,
        pageSize: pageSizes,
        search: false,
        toolbar: true,

    };

    const columns = [
        {
            title: "",
            field: "id",
            width: "4%",
            render: (rowData) => <span>&nbsp;</span>,
        },
        {
            title: "Band",
            field: "band",
        },
        {
            title: "Min QTY",
            field: "min_quantity",
        },
        {
            title: "Units",
            field: "units",
            headerStyle: {
                textAlign: "left",
                width: "40%"
            },
            cellStyle: {
                textAlign: "left",
                paddingLeft: '15px',
                width: "40%"
            }
        },
        {
            title: "Discount",
            field: "discount",
            render: (rowData) => rowData.discount ? `${rowData.discount}%` : '',
        },
        {
            title: "Unit Price",
            field: "unit_price",
            render: (rowData) => handlePriceBreakUnitPrice(rowData)

        },
        {
            title: "Action",
            field: "actual_man_hours",
            render: (rowData) => rowData?.band > 1 ?
                < Box >

                    <IconButton
                        disabled={!props.permission.write || disabled}
                        style={{ display: !props.permission.write && "none" }}
                        onClick={() => {
                            setActions("edit_price");
                            setCurrentSelectedData(rowData);
                        }}
                    >
                        <EditIcon fontSize="small" htmlColor={ICON_COLOUR} />
                    </IconButton>
                    {rowData?.highest_value ?
                        <IconButton
                            disabled={!props.permission.write || disabled}
                            onClick={() => {
                                setActions("delete_price");
                                setCurrentSelectedData(rowData);
                            }}
                        >
                            <DeleteIcon fontSize="small" htmlColor={ICON_COLOUR} />
                        </IconButton> : <span style={{ paddingLeft: '14px' }}></span>}
                </Box > : ''
        }

    ];
    const handleQuantityBasePrice = (value) => {
        if (value) {
            if (value === 'no' && priceBreakDetails.length > 1) {
                message.showToastMessage({
                    message: "“Remove Price Breaks First!",
                    variant: "error",
                });
                handlePopup();
                setQuantityPrice('yes');
            }

            else {
                handlePopup();
                setQuantityPrice(value);
            }
        }
    };


    const handleSubmitPriceBreak = () => {
        setBusy("loading")
        BoxpDataService.boxpDeleteData(currentSelectedData?.id, 'deletePriceBreak', currentSelectedData).then((res) => {
            if (res.success) {
                setBusy(null);
                getAllPriceBreaks();
                setActions(null);
                message.showToastMessage({ message: "Deleted successfully", variant: "success" });
            } else {
                setBusy(null);
                setActions(null);
                message.showToastMessage({ message: "Something went wrong!!", variant: "error" });
            }
        })
    }


    return (
        <div>


            <Grid style={{ marginBottom: "1px" }}>
                <Typography color="primary" variant="body1">Job Pricing</Typography>
            </Grid>
            <Grid container xs={12} >
                <Grid container item xs={12} md={10} spacing={4} style={{ marginBottom: 20 }}>
                    <Grid item xs={2}>
                        <MROTextField
                            name="labour"
                            label="Labour"
                            disabled={!props.permission.write}
                            value={input.labour}
                            type="number"
                            placeholder={"0.00"}
                            error={errors.labour}
                            onChange={(e) => {
                                resetErrorsHandler(e.target.name);
                                handleInput(e);
                            }}
                            InputProps={{
                                className: disabled
                                    ? classes.disableField
                                    : projectState && classes.disableField,
                            }}
                            InputLabelProps={{ shrink: true }}
                        ></MROTextField>
                    </Grid>
                    <Grid item xs={2}>
                        <MROTextField
                            name="parts"
                            label="Parts"
                            value={input.parts}
                            error={errors.parts}
                            disabled={!props.permission.write}
                            type="number"
                            placeholder={"0.00"}
                            onChange={(e) => {
                                resetErrorsHandler(e.target.name);
                                handleInput(e);
                            }}
                            InputProps={{
                                className: disabled
                                    ? classes.disableField
                                    : projectState && classes.disableField,
                            }}
                            InputLabelProps={{ shrink: true }}
                        ></MROTextField>
                    </Grid>
                    <Grid item xs={2}>
                        <MROTextField
                            name="services"
                            label="Services"
                            value={input.services}
                            error={errors.services}
                            disabled={!props.permission.write}
                            type="number"
                            placeholder={"0.00"}
                            onChange={(e) => {
                                resetErrorsHandler(e.target.name);
                                handleInput(e);
                            }}
                            InputProps={{
                                className: disabled
                                    ? classes.disableField
                                    : projectState && classes.disableField,
                            }}
                            InputLabelProps={{ shrink: true }}
                        ></MROTextField>
                    </Grid>

                    <Grid item xs={2}>
                        <MROTextField
                            name="equipment"

                            label="Equipment"
                            value={input.equipment}
                            error={errors.equipment}
                            disabled={!props.permission.write}
                            type="number"
                            placeholder={"0.00"}
                            onChange={(e) => {
                                resetErrorsHandler(e.target.name);
                                handleInput(e);
                            }}
                            InputProps={{
                                className: disabled
                                    ? classes.disableField
                                    : projectState && classes.disableField,
                            }}
                            InputLabelProps={{ shrink: true }}
                        ></MROTextField>
                    </Grid>





                    {/* Unit Total */}
                    <Grid className={classes.purchaseGrid} item xs={2}>
                        <MROTextField
                            name="total"
                            label="Unit Total *"
                            value={parseFloat(sum).toFixed(2)}
                            error={errors.total}
                            placeholder="0.00"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ className: classes.disableField }}
                        />
                        <Grid
                            style={{
                                background: theme.palette.primary.main,
                                width: "100%",
                                height: "0.5px",
                            }}
                        />
                    </Grid>

                    <Grid item xs={2}>
                        <MROTextField
                            name="aog_fee"
                            label="Other (1 off)"
                            value={input.aog_fee}
                            error={errors.aog_fee}
                            disabled={!props.permission.write}
                            type="number"
                            placeholder={"0.00"}
                            onChange={(e) => {
                                resetErrorsHandler(e.target.name);
                                handleInput(e);
                            }}
                            InputProps={{
                                className: disabled && classes.disableField

                            }}
                            InputLabelProps={{ shrink: true }}
                        ></MROTextField>
                    </Grid>


                </Grid>
                {!projectState && <Grid item xs={12} md={2} style={{ textAlign: "center", paddingTop: "21px", paddingLeft: "31px" }}>

                    <MROButton
                        disabled={disabled || !props?.permission.write}
                        type="button"
                        variant={"contained"}
                        onClick={() => {
                            if (cusExist === "yes") {
                                if (selectedCustomerId?.id !== undefined) {

                                    setRate(selectedCustomerId?.currency?.sales_rate)
                                    setActions("lookup")
                                }
                                else {
                                    message.showToastMessage({
                                        message: "Select Customer First!",
                                        variant: "error",
                                    });

                                }

                            }
                            else if (cusExist === "no") {
                                setActions("lookup")

                            }

                        }}
                        color="primary"
                        startIcon={<RestoreIcon size="small" />}
                    >
                        <Typography style={{ whiteSpace: "nowrap" }}>Lookup Pricing</Typography>
                    </MROButton>
                </Grid>}




            </Grid>
            {/* shipping details */}
            <Grid
                style={{ marginBottom: "1px" }}
                container
                spacing={3}
                alignItems={"center"}
                justify={"flex-start"}
            >
                <Grid className={classes.purchaseGrid} item xs={3}>
                    <MROTextField
                        name={"shipping_type"}
                        label={"Shipping Type *"}
                        placeholder={"Select"}
                        select
                        requird
                        InputProps={{
                            className: disabled && classes.disableField,
                        }}
                        value={filterData?.shipping_type}
                        InputLabelProps={{ shrink: true }}
                        error={errors.shipping_type}
                        onChange={(e) => {
                            resetErrorsHandler(e.target.name);
                            setFilterData((ps) => ({ ...ps, shipping_type: e.target.value }))
                            handlePopup();
                        }}
                    >
                        <MenuItem value={0}>Excludes Shipping</MenuItem>
                        <MenuItem value={1}>Customer Delivery & Collection</MenuItem>
                        <MenuItem value={2}>MRO Collection & Delivery</MenuItem>
                        <MenuItem value={3}>MRO Arranged 3rd Party Agent</MenuItem>

                    </MROTextField>
                </Grid>
                {[2, 3].includes(filterData.shipping_type) && <Grid item xs={3}>
                    <NumericIncrement
                        name="shipping_fee"
                        label="Shipping Fee *"
                        error={errors.shipping}
                        value={states.man_hours}
                        placeholder={"Value "}
                        disable={disabled}
                        InputProps={{
                            className: disabled && classes.disableField,
                        }}
                        noIncreament
                        state={states}
                        setState={setStates}
                        inputProps={{ min: 0, step: 0.25 }}
                        InputLabelProps={{ shrink: true }}
                        setError={() => resetErrorsHandler("shipping_fee")}
                        helperText={
                            errors["shipping_fee"] &&
                            `Please enter shipping fee`
                        }
                    />

                </Grid>}
            </Grid>
            <Box
                display="flex"
                alignItems="center"
                margin="0 auto"
                mt="0px"
                mb="23px"
            >
                <WarningIcon
                    style={{ color: "#FFB300" }}
                    fontSize="20px"
                />{" "}
                <Typography
                    className={classes.bodyText}
                    style={{ marginBottom: 0 }}
                >
                    <span style={{ padding: "5px" }}>
                        This customer’s currency is{" "}
                        <span className={classes.currencyName}>
                            {action === "Unlock" && quoteId != null
                                ? selectedCustomerId?.currency?.currency_name
                                : (cusExist === "yes"
                                    ? selectedCustomerId?.currency?.currency_name
                                    : cusExist === "no"
                                        ? currencyName
                                        : "") || "-"}
                        </span>{" "}
                        Quote all figures in the customer’s rate using the current
                        sales exchange rate of:{" "}
                        <span className={classes.currencyName}>
                            {action === "Unlock" && quoteId != null
                                ? selectedCustomerId?.currency?.sales_rate
                                : (cusExist === "yes"
                                    ? selectedCustomerId?.currency?.sales_rate
                                    : cusExist === "no"
                                        ? salesRate
                                        : "") || "-"}
                        </span>
                    </span>
                </Typography>
            </Box>
            <Grid
                style={{ marginTop: "8px", marginBottom: "8px", background: "transparent" }}
                className={disabled || access.read || quotation?.linked_storage_order_id != null ? classes.disableField : null}
            >
                <YesNoField
                    disabled={disabled || !props.permission.write || quotation?.linked_storage_order_id != null}
                    label="Send detailed cost breakdown (Includes Labour, Parts, Services and Equipment)?"
                    name="detailed_breakdown"
                    handleToggle={handleBreakDown}
                    value={detailedBreakDown}
                    error={errors.detailed_breakdown}
                    setError={() => {
                        resetErrorsHandler("detailed_breakdown");
                    }}
                />
            </Grid>
            {
                !projectState && <Grid
                    style={{ marginTop: "8px", marginBottom: "8px", background: "transparent" }}
                    className={disabled || access.read || quotation?.linked_storage_order_id != null ? classes.disableField : null}
                >
                    <YesNoField
                        disabled={disabled || !props.permission.write || quotation?.linked_storage_order_id != null}
                        label="Add quantity based price breaks?"
                        name="quantity_based_price_breaks"
                        handleToggle={handleQuantityBasePrice}
                        value={quantityPrice}
                        error={!projectState && errors.quantity_based_price_breaks}
                        setError={() => {
                            resetErrorsHandler("quantity_based_price_breaks");
                        }}
                    />
                </Grid>
            }

            {
                !projectState && quantityPrice === 'yes' &&
                <MaterialTable
                    style={{ boxShadow: "0px 1px 3px #00000033", marginTop: "10px" }}
                    icons={tableIcons}
                    isLoading={loading}
                    columns={columns}
                    data={priceBreakDetails || []}
                    options={tableOptions}
                    localization={{
                        body: {
                            emptyDataSourceMessage: "No Records Found",
                        },
                    }}
                    onChangePage={(page) => {
                        setPages(page);
                    }}
                    onChangeRowsPerPage={(pageSize) => {
                        setPageSizes(pageSize);
                    }}
                    totalCount={totalCounts}
                    page={pages}
                    actions={props?.permission.write && [
                        {
                            icon: () => (
                                <div style={{ display: access.read ? "none" : undefined }}>
                                    <AddIconBox color="primary" />
                                </div>
                            ),
                            tooltip: "Add",
                            hidden: disabled,
                            isFreeAction: true,
                            onClick: () =>
                                setActions('add_qty_price'),
                        },
                    ]}
                />
            }

            <Grid style={{ marginBottom: "20px", marginTop: "20px" }}>
                <MROButton variant={"contained"}>Quote Comments</MROButton>
            </Grid>

            <Grid container alignItems={"center"} justify={"flex-start"}>
                <Grid item xs={12}>
                    <MROTextField
                        name={"quote_comments"}
                        label={"Quote Comments *"}
                        disabled={!props.permission.write}
                        multiline
                        placeholder="Enter scope and any further details or charges here. E.g, travel, accommodation etc. Max 1000 characters"
                        InputProps={{
                            style: {
                                height: 'max-content',
                                width: "100%",
                                pointerEvents: disabled && "none",
                                backgroundColor: disabled && "#F5F5F5",
                            },
                        }}
                        inputProps={{ maxLength: 1000 }}
                        value={quoteComments}
                        InputLabelProps={{ shrink: true }}
                        error={errors.quote_comments}
                        onChange={(e) => {
                            resetErrorsHandler(e.target.name);
                            setQuoteComments(e.target.value);
                            handlePopup();
                        }}

                    // className={classes.inputField}
                    />
                </Grid>
            </Grid>
            <Grid style={{ marginBottom: "20px", marginTop: "20px" }}>
                <MROButton variant={"contained"}>Internal Remarks</MROButton>
            </Grid>
            <Grid item xs={12}>
                <MROTextField
                    name={"internal_notes"}
                    label={"Internal Notes"}
                    disabled={!props.permission.write}
                    multiline
                    placeholder="Enter any internal notes. These will NOT go to the customer and are for internal reference only. Max 2000 characters"
                    InputProps={{
                        style: {
                            height: 'max-content',
                            width: "100%",
                            pointerEvents: disabled && "none",
                            backgroundColor: disabled && "#F5F5F5",
                        },
                    }}
                    inputProps={{ maxLength: 2000 }}
                    value={internalNotes}
                    InputLabelProps={{ shrink: true }}
                    // error={errors.quote_comments}
                    onChange={(e) => {
                        // resetErrorsHandler(e.target.name);
                        setInternalNotes(e.target.value);
                        handlePopup();
                    }}

                // className={classes.inputField}
                />
            </Grid>
            <Grid style={{ marginBottom: "20px", marginTop: "20px" }}>
                <MROButton variant={"contained"}>Internal Files</MROButton>
            </Grid>
            <Grid>
                {isGettingDetails ? <Grid item xs={12} style={{
                    border: `1px solid ${theme.palette.primary.main}`, borderRadius: "10px", height: "103px",
                    textAlign: "center",
                    alignContent: "space-around"
                }}> <CircularProgress color={"primary"} size={20} /> </Grid> :
                    <FileUpload
                        defaultValue={quotation?.internal_files !== undefined
                            && quotation?.internal_files.map((file) => ({
                                filename: file?.file_name,
                                url: file?.path,
                                id: file?.id,
                            }))
                        }
                        uploadButtonView={disabled === true}
                        setFiles={(files) => { setInternalFiles(files) }}
                        showBorderOnNoFiles={true}
                        accept={"multiple"}
                        name="internal_files[]"
                        multiple={true}
                        APIUrl={""}
                        action={"Upload Document"}
                        onDelete={disabled ? null : deleteFileHandler}
                        isDeleting={busy === "file-deleting"}
                        viewOnly={disabledAccptance || !props.permission.write}
                    />}
            </Grid>
            <br />

            {actions && actions === 'add_qty_price'
                &&
                <PriceBrand
                    handleClose={() => setActions(null)}
                    open={action}
                    action={actions}
                    getAllPriceBreaks={getAllPriceBreaks}
                    unit_total={parseFloat(sum).toFixed(2)}
                    workshop_order_id={workshop_order_id || quotation?.workshop_order_id}
                />
            }

            {actions && actions === 'edit_price'
                &&
                <PriceBrand
                    handleClose={() => setActions(null)}
                    open={action}
                    action={actions}
                    getAllPriceBreaks={getAllPriceBreaks}
                    unit_total={parseFloat(sum).toFixed(2)}
                    workshop_order_id={workshop_order_id || quotation?.workshop_order_id}
                    currentSelectedData={currentSelectedData}
                />
            }
            {actions && actions === "lookup" && (
                <PartPricing handleClose={() => setActions(null)}
                    currentWorkshopDetails={{
                        quantity: "1",
                        part_number: selectedPart?.part_number,
                        description: selectedPart?.description,
                        salesRate: cusExist === "no" ? "1" : rate
                    }}
                    setInput={setInput}
                    input={input}
                    name={"quote"}
                    setTatquantity={setTatquantity}
                    setStandardId={setStandardId}
                    salesRate={salesRate}
                />

            )}
            {actions && actions === "delete_price" &&
                <Dialog
                    maxWidth={"md"}
                    fullWidth={true}
                    open={actions === "delete_price"}
                    className={classes.modal}
                    onClose={() => setActions(null)}
                >
                    <DialogTitle>
                        <Typography color="primary" className={classes.title}>
                            Delete Item
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Typography className={classes.warning}>
                            This cannot be undone. Are you sure?
                        </Typography>
                        <Grid className={classes.actionButtons} spacing={1} container style={{ paddingBottom: '20px' }}>
                            <Grid item>
                                <MROButton
                                    type="button"
                                    variant={"contained"}
                                    onClick={() => setActions(null)}
                                >
                                    Cancel
                                </MROButton>
                            </Grid>
                            <Grid item>
                                <MROButton
                                    loading={busy === "loading"}
                                    onClick={handleSubmitPriceBreak}
                                    type="submit"
                                    variant={"contained"}
                                    color="primary"
                                >
                                    Yes
                                </MROButton>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>}
        </div >
    )
}
